import React from 'react'
import {Grid, Row, Col, FormControl, Button} from 'react-bootstrap'

import { store } from '../../../store'

const initialState = {
      password: '',
      newpassword: '',
      confirmpassword: '',
      status: '',
      error: '',
      deact: false,
      deact_password: ''
}

class ChangePassword extends React.Component {
constructor(props) {
	super(props)
	this.state = initialState
}
onStatus = (text) => {
  this.setState({status: text})
}
onDeactivate = () => {
	this.setState({status: 'deleting'})
	if(this.state.deact_password !== '') {
		fetch(`${process.env.REACT_APP_API}/deactivate`, {
      	method: 'post',
      	headers: {'Content-Type': 'application/json'},
      	body: JSON.stringify({
			user: {
		      	username: store.getState().user.user.username,
				password: this.state.deact_password
	  		},
			token: store.getState().user.token
    		})
    	})
    	.then((response)=>{
    		response.json()
    		.then((data)=> {
    			if(data.user) {
					localStorage.clear()
					window.location = '/'
    			}
    			else {
    				this.setState({error: 'deact_password'})
    			}
    		})
    	})
	}
	else {
		this.setState({status: ''})
		this.setState({error: 'deact_password'})
	}
}
submitPassword = () => {
	let {password, newpassword, confirmpassword} = this.state
	this.onStatus('processing')
	if(password === '' && newpassword === '' && confirmpassword === '') {
  		this.setState({error: 'empty'})
	}
	else if(password === '') {
  		this.setState({error: 'oldpassword'})
	}
	else if(newpassword === '') {
  		this.setState({error: 'newpassword'})
	}
	else if(confirmpassword === '') {
  		this.setState({error: 'confirmpassword'})
	}
  	else if(newpassword === confirmpassword) {
  		fetch(`${process.env.REACT_APP_API}/settings`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
		  password: password,
		  newpassword: newpassword,
	      token: store.getState().user.token,
	      username: store.getState().user.user.username,
	      user: {}
    })
    })
  		.then(response => {
  			if(response.status === 400) {
			this.setState({error: 'oldpassword'})
		}
			else {
  			response.json()
  			.then(data => {
        	if (data.Password === 'Password changed succesfully') {
			this.setState({
			    password: '',
			    newpassword: '',
			    confirmpassword: '',
			    error: '',
				status: 'success'
			})
			}
		})
  		}
  		})
  	}
  	else {
  		this.setState({error: 'missmatch'})
  	}
	if(this.state.status === 'success') {
	setTimeout(
    function() {
        this.setState({ status: '' })
    }
    .bind(this),
    3000
	)
	}
}
onButton = () => {
   	if(this.state.status === '')
   	return this.submitPassword()
   	else return null
}
	render(props) {
	let {Rolling} = this.props
	let {status} = this.state
	if(this.state.status === 'success') {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    2000
			)
			}
	if(this.state.error) {
			setTimeout(
		    function() {
		        this.setState({ status: '' })
		    }
		    .bind(this),
		    800
			)
			}
	return (<div className="settings_inside">
		<div className="settings_inside_content">
		<Grid>
		<h3>Change Password</h3>
		<Row className="settings_sections">
		<Col lg={8} md={8} sm={6} xs={10}><FormControl 
            spellcheck="false"
	        className={
	        	this.state.error === 'oldpassword' || this.state.error === 'empty'
	        	? 'settings_form redd'
	        	: 'settings_form'
	        }
	        onFocus={()=> this.setState({error: ''})}
            autocomplete="off"
            type="password" 
            name="old_password"
            placeholder="Current Password"
            value={this.state.password}
            onChange={(e)=>this.setState({password: e.target.value})}
            size="6"
          />
         </Col>
         </Row>
         <Row className="settings_sections">
	      <Col lg={8} md={8} sm={6} xs={10}>
	      <FormControl 
	        spellcheck="false"
	        className={
	        	this.state.error === 'newpassword' || this.state.error === 'missmatch' || this.state.error === 'empty'
	        	? 'settings_form redd'
	        	: 'settings_form'
	        }
	        onFocus={()=> this.setState({error: ''})}
	        autocomplete="off"
	        type="password" 
	        name="new_password"
	        placeholder="New Password"
            value={this.state.newpassword}
            onChange={(e)=>this.setState({newpassword: e.target.value})}
	        size="6"
	      />
	      </Col>
	      </Row>
	      <Row className="settings_sections">
          <Col lg={8} md={8} sm={6} xs={10}>
          <FormControl 
            spellcheck="false"
            className={
	        	this.state.error === 'confirmpassword' || this.state.error === 'missmatch' || this.state.error === 'empty'
	        	? 'settings_form redd'
	        	: 'settings_form'
	        }
	        onFocus={()=> this.setState({error: ''})}
            autocomplete="off"
            type="password" 
            name="repeat_password"
            placeholder="Repeat New Password"
            value={this.state.confirmpassword}
            size="6"
            onChange={(e)=>this.setState({confirmpassword: e.target.value})}
          />
          </Col>
	      </Row>
	      <Row className="settings_sections">
	      <Col lg={8} md={8} sm={6} xs={10}>
	      <Button className={status === 'success'
	      ?	'btn_save'
	      : 'top_btn'
	      }
	       onClick={this.onButton.bind()}>
	      {status === 'processing'
	      ?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
	      : null
	 		}
	 		{status === 'success'
	      ?	<span className="rolling"><svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span>
	      : null
	  }
	  	{(status === '' || status === 'deleting')
	      ?<div className="rolling_save"><span>Save</span></div>
	      : null
	 		}
		</Button>
		</Col>
		</Row>
		<h3>Deactivate your Account</h3>
		<Row>
		<Col lg={8} md={8} sm={6} xs={10} className="settings_sections">
		<span className="deact_btn" onClick={()=>this.setState({deact: !this.state.deact})}>Deactivate</span>
		</Col>
		</Row>
		{
			this.state.deact
			? 	<Row>
				<Col lg={6} md={8} sm={8} xs={10} className="settings_sections outerdeact">
				<div className="deactivate_section">
				<div className="deact_warn">
				<p>* Account will be removed completely only after 30 days (deactivation time period) from the time you deactivate.</p>
				<p>* Reactivate your account before deactivation expires by just signin in.</p>
				<p>* Your data won't be lost during the time of deactivation, it will be removed only after deactivation expires.</p></div>
				<div className="deact_text">Confirm with your password</div>
				<FormControl  
			        	className={
				        	this.state.error === 'deact_password'
				        	? 'settings_form redd'
				        	: 'settings_form'
	        			}
			        	type="password" 
			        	name="password" 
			        	placeholder="Password" 
			        	onFocus={()=> this.setState({error: ''})}
			        	value={this.state.deact_password}
			        	onChange={(e)=>{
			        		this.setState({deact_password: e.target.value})
			        	}}
			        />
			    <br />
			    <Button className="top_btn"
			       onClick={this.onDeactivate.bind()}>
			      {status === 'deleting'
			      ?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
			      : null
			 		}
			  		{(status !== 'deleting')
			      ?<div className="rolling_save"><span>Confirm</span></div>
			      : null
			 		}
				</Button>
			    </div>
				</Col>
				</Row>
			: null
		}
		</Grid>
		</div>
		</div>)
}
}
export default ChangePassword